import { Badge } from "reactstrap"

const color = (item) => {
    let color = ""
    item?.leave_status === "3" ||
    item?.leave_status === "4"
      ? color = "primary"
      : item?.leave_status === "5"
      ? color = "success"
      : item?.leave_status === "6" ||
        item?.leave_status === "8" 
      ? color = "danger"
      : item?.leave_status === "9"
      ? color = "warning"
      : item?.leave_status === "A" ||
        item?.leave_status === "B" ||
        item?.leave_status === "C" ||
        item?.leave_status === "7"
      ? color = "white"
      : color = "secondary"
    return color
}

export const leaveStatusBadge = (item, cancelDate = false) => {

    let status_leave = "";
    let textColor = null;

    if (item?.leave_status === "0")
      status_leave = "อนุมัติ";
     if (item?.leave_status === "2")
      status_leave = "รออนุมัติ";
    if (item?.leave_status === "3")
      // status_leave = "อนุญาต";
      status_leave = "รออนุมัติ";
    if (item?.leave_status === "4")
      status_leave = "รออนุญาต";
    if (item?.leave_status === "5")
      status_leave = "อนุมัติ";
    if (item?.leave_status === "6")
      status_leave = "ไม่อนุมัติ";
    if (item?.leave_status === "7")
      // status_leave = "ขอยกเลิกใบลา";
      {status_leave = "รออนุญาต";
      textColor = cancelDate ? "primary" : "warning"}
    if (item?.leave_status === "8")
      status_leave = "ยกเลิก";
    if (item?.leave_status === "9")
      status_leave = "ส่งกลับแก้ไข";
    if (item?.leave_status === "A")
      // status_leave = "อนุมัติยกเลิก";
      {status_leave = "อนุมัติ";
      textColor = "danger"}
    if (item?.leave_status === "C")
      // status_leave = "อนุมัติยกเลิกบางวัน";
      {status_leave = "อนุมัติ";
      textColor = "success"}
    if (item?.leave_status === "B")
      // status_leave = "อนุญาตยกเลิก";
      {status_leave = "รออนุมัติ";
      textColor = cancelDate ? "primary" : "warning"}
    if (item?.status_leave === null)
      status_leave = "ไม่มีข้อมูล";

    let borderClassName = `border border-${textColor}`;

      return   (<Badge
          pill
          className={`${textColor ? borderClassName : color(item)} text-${textColor}`}
          color={color(item)}
        >
          {status_leave}
        </Badge>)
}